import closeicon from "../../../assets/images/close.svg";
import useLanguageTranslate from "../../../hooks/useLanguageTranslate";
import BackdropModal from "../../common/modal/backdropModal";

const benefitsData = [
  {
    description: "Death due to any cause",
    description_ar: "الوفاة لأي سبب كان",
    benefits: "BHD 3,000",
    benefits_ar: "3,000 د.ب",
  },
  {
    description: "Permanent partial or total disability due to accident",
    description_ar: "العجز الجزئي أو الكلي الدائم بسبب حادث",
    benefits: "BHD 1,500",
    benefits_ar: "1,500 د.ب",
  },
  {
    description: "Critical Illness",
    description_ar: "الأمراض الحرجة",
    benefits: "BHD 500",
    benefits_ar: "500 د.ب",
  },
  {
    description: "Medical Expenses due to Accident",
    description_ar: "النفقات الطبية بسبب الحادث",
    benefits: "BHD 500",
    benefits_ar: "500 د.ب",
  },
  {
    description: "Mortal Remains Repatriation",
    description_ar: "إعادة جثامين الموتى",
    benefits: "BHD 1,000",
    benefits_ar: "1,000 د.ب",
  },
  {
    description:
      "Absence from work in violation to the terms of the work Permit *",
    description_ar: "الغياب عن العمل بما يخالف شروط تصريح العمل *",
    benefits: "As per request",
    benefits_ar: "حسب الطلب",
  },
];

const DomesticHelperBenefitsModal = ({ show, onClose }) => {
  const translate = useLanguageTranslate();

  if (!show) return null;

  return (
    <BackdropModal show={show} onClose={onClose} hideClosebtn>
      <div className="w-full min-w-[780px] max-w-[820px] max767:min-w-0 max767:max-w-full ipad:min-w-0">
        <div className="max767:-mx-6">
          {/* Header */}
          <div className="flex justify-between items-center mb-6 -mt-6 max767:px-6 max767:gap-8">
            <h2 className="text-[#1A2024] text-2xl font-semibold max767:text-xl">
              {translate(
                "Domestic Helper insurance benefits & covers",
                "مزايا وتغطيات تأمين العمالة المنزلية"
              )}
            </h2>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-full flex-shrink-0 max767:bg-[#E5E9EB]"
            >
              <img src={closeicon} alt="Close" className="w-6 h-6" />
            </button>
          </div>

          {/* Table Container with border and radius */}
          <div className="w-full max-h-[55vh] overflow-y-auto overflow-x-auto border border-[#DDE2E4] rounded-xl max767:border-0 max767:rounded-none">
            {/* Benefits Table */}
            <table className="w-full border-collapse">
              <thead>
                <tr className="sticky top-0 z-10 bg-[#F6F8F9] border-b border-[#DDE2E4]">
                  <th className="text-left rtl:text-right p-4 text-[#252C32] text-lg font-semibold w-[60%] max767:text-[#252C32] max767:font-semibold max767:text-sm max767:py-[24px] max767:px-[20px]">
                    {translate("Description", "التفاصيل")}
                  </th>
                  <th className="text-left rtl:text-right p-4 text-[#252C32] text-lg font-semibold w-[40%] max767:text-[#252C32] max767:font-semibold max767:text-sm max767:py-[24px] max767:px-[20px]">
                    {translate("Benefits & Covers", "المزايا والتغطيات")}
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white">
                {benefitsData.map((benefit, index) => (
                  <tr
                    key={index}
                    className="border-b border-[#DDE2E4] last:border-b-0"
                  >
                    <td className="p-4 text-left rtl:text-right text-[#252C32] text-base font-semibold align-top max767:text-[#252C32] max767:font-semibold max767:text-sm max767:py-[16px] max767:px-[20px]">
                      {translate(benefit.description, benefit.description_ar)}
                    </td>
                    <td className="p-4 text-left rtl:text-right text-[#252C32] text-base font-semibold align-top max767:text-[#252C32] max767:text-sm max767:py-[16px] max767:px-[20px]">
                      {translate(benefit.benefits, benefit.benefits_ar)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </BackdropModal>
  );
};

export default DomesticHelperBenefitsModal;
